import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { NotFoundPageComponent } from './auth/containers/not-found-page/not-found-page.component'
import { AuthGuard } from './auth/guards/auth.guard'
import { PrevAuthGuard } from './auth/guards/prev-auth.guard'
import { AppMainPageComponent } from './core/containers/app-main-page/app-main-page.component'

const routes: Routes = [
  // { path: '', redirectTo: 'site/index', pathMatch: 'full' },
  { path: '', loadChildren: () => import('./landing/landing.module').then((m) => m.LandingModule) },
  { path: 'survey', loadChildren: () => import('./survey/survey.module').then((m) => m.SurveyModule) },
  { path: 'public-survey', loadChildren: () => import('./survey/survey.module').then((m) => m.SurveyModule) },
  { path: 'auth', canActivate: [PrevAuthGuard], loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule) },
  { path: 'app',
    component: AppMainPageComponent,
    children: [
      {
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        path: '',
        data: { permission: 'GLOBAL'},
        loadChildren: () => import('./core/core.module').then((m) => m.CoreModule)
      },
      {
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        path: 'tags',
        data: { permission: 'GLOBAL'},
        loadChildren: () => import('./tags/tags.module').then(m => m.TagsModule)
      },
      {
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        path: 'reports',
        data: { permission: 'GLOBAL'},
        loadChildren: () => import('./reports/reports.module').then((m) => m.ReportsModule)
      },
      {
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        path: 'users',
        data: { permission: 'GLOBAL'},
        loadChildren: () => import('./users/users.module').then((m) => m.UsersModule)
      }
    ]
  },
  { path: '**', component: NotFoundPageComponent}
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
